<template>
  <div class="role-setting">
    <el-card
      class="box-card menu"
      header="角色管理"
    >
      <el-button
        type="text"
        class="add-role"
        @click="createRoleVisible = true"
      >
        <i class="el-icon-circle-plus-outline add-role-icon" />
      </el-button>
      <ul class="role-list">
        <li
          v-for="(item, index) in rolesList"
          :key="item.role_id"
          :class="index === currentKey ? 'role-selected' : ''"
          @click="clickRole(item, index)"
        >
          <div class="role-name">
            {{ item.role_name }}
          </div>
          <el-tooltip
            v-if="!item.is_system"
            placement="bottom"
            effect="light"
          >
            <div
              slot="content"
              class="operation"
            >
              <div>
                <el-button
                  type="text"
                  @click="updateName(item)"
                >
                  重命名
                </el-button>
              </div>
              <div>
                <el-button
                  type="text"
                  @click="deleteRoleAction(item)"
                >
                  <span style="color: #f56c6c">删除</span>
                </el-button>
              </div>
            </div>
            <div class="list-more">
              <i class="el-icon-more" />
            </div>
          </el-tooltip>
        </li>
      </ul>
    </el-card>

    <el-card class="box-card list">
      <div
        slot="header"
        class="header"
      >
        {{ currentRole.role_name }}（{{ totalNumber }}）
        <span>{{ roleTips[currentRole.role_name] || '' }}</span>
      </div>
      <div class="list-content">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="成员列表"
            name="list"
          >
            <div class="f-table-block">
              <el-table
                v-loading="tableloading"
                :data="userList"
                style="width: 100%"
              >
                <el-table-column label="成员名称">
                  <template slot-scope="scope">
                    <div class="member">
                      <div class="member-image">
                        <img
                          v-if="scope.row.avatar"
                          :src="scope.row.avatar"
                          alt=""
                          srcset=""
                        >
                        <img
                          v-else
                          src="@/assets/img/default_avatar.png"
                          alt=""
                        >
                      </div>
                      <div class="member-info">
                        <div class="member-name">
                          {{ scope.row.user_name }}
                        </div>
                        <div
                          v-if="scope.row.alias"
                          class="member-alias"
                        >
                          别名：{{ scope.row.alias }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="name"
                  label="所在部门"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <ul
                      v-for="(item, index) in scope.row.department"
                      :key="index"
                      class="department-list"
                    >
                      <li>{{ item }}</li>
                    </ul>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot="header">
                    <span>激活状态</span>
                    <el-tooltip
                      effect="dark"
                      content="成员在企业微信中的激活状态"
                      placement="top"
                    >
                      <i class="el-icon-info tooltip" />
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <span>{{ listState[scope.row.state] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      :disabled="scope.row.type == 'admin'"
                      @click="updateRole(scope.row)"
                    >
                      变更角色
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                class="table-pagination"
                background
                :current-page="params.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="params.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total_count"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="权限范围"
            name="setting"
          >
            <div class="setting-content">
              <Tree
                ref="SetTrees"
                :row-data="treeData"
                :tree-checked-keys="defaultCheckedKeys"
                :current-role="currentRole"
                :expand-all="true"
              />
              <div
                v-if="!currentRole.is_system"
                class="setting-btn"
              >
                <el-button
                  type="primary"
                  @click="submitSetting"
                >
                  保 存
                </el-button>
                <el-button
                  type="primary"
                  plain
                  @click="activeName = 'list'"
                >
                  取 消
                </el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div
          v-if="activeName === 'list'"
          class="list-search"
        >
          <el-input
            v-model="params.username"
            placeholder="成员名称"
            size="small"
            clearable
            @change="searchUser"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @change="searchUser"
            />
          </el-input>
        </div>
      </div>
    </el-card>

    <!-- 新建角色 -->
    <CreateRole
      v-model="createRoleVisible"
      @refresh="getRolesList"
    />

    <!-- 操作-变更角色 -->
    <SpSetRole
      v-model="permissionsVisible"
      :update-item="updateItem"
      @refresh="getUser"
    />

    <!-- 变更角色昵称 -->
    <SetRoleName
      v-model="updateNameVisible"
      :update-item="setRoleItem"
    />

    <!-- 删除模态框 -->
    <el-dialog
      title="删除角色"
      :visible.sync="deleteDialogVisible"
      width="550px"
      :before-close="deleteDialogBeforeClose"
    >
      <div>
        <span v-if="deleteItem.user_count < 1">确定删除「{{ deleteItem.role_name }}」角色吗？</span>
        <span
          v-else
        >该角色中有
          {{ deleteItem.user_count }} 名成员，请先将成员设置为其他角色后再尝试删除。</span>
      </div>
      <div slot="footer">
        <el-button @click="deleteDialogVisible = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="submitDeleteRole"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Tree from './comps/tree'
import CreateRole from './comps/role'
import SetRoleName from './comps/setRoleName'
export default {
  components: {
    Tree,
    CreateRole,
    SetRoleName
  },
  data () {
    return {
      form: {
        role_name: '',
        role_id: '',
        permission: []
      },
      rolesList: [],
      activeName: 'list',
      total_count: 0,
      params: {
        username: '',
        page: 1,
        page_size: 20,
        role: 0
      },
      userList: [],
      defaultCheckedKeys: [],
      currentKey: 0,
      tableloading: false,
      listState: {
        1: '已激活',
        2: '已禁用',
        4: '未激活',
        5: '退出企业'
      },
      totalNumber: 0,
      createRoleVisible: false,
      treeData: {},
      currentRole: {},
      roleTips: {
        '超级管理员': '系统开通人员，拥有系统全部权限',
        '管理员': '拥有系统全部权限',
        '普通员工': '无系统任何权限，无法登陆系统'
      },
      permissionsVisible: false,
      updateItem: {},
      updateNameVisible: false,
      setRoleItem: {},
      deleteDialogVisible: false,
      deleteItem: {}
    }
  },
  computed: {
    ...mapGetters([])
  },
  mounted () {
    this.getRolesList()
  },
  methods: {
    // 删除角色
    async deleteRoleAction (row) {
      const data = await this.$api.setting.getRolesList()
      if (data) {
        let editItem = data.list.filter((v) => v.role_id === row.role_id)
        this.deleteItem = editItem[0]
        this.deleteDialogVisible = true
      }
    },
    // 确定删除角色
    submitDeleteRole () {
      let { role_id, user_count } = this.deleteItem
      if (user_count < 1) {
        this.$api['setting/roleSetting'].deleteRole(role_id).then((response) => {
          this.getRolesList()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.deleteDialogVisible = false
        })
      } else {
        this.deleteDialogVisible = false
      }
    },
    deleteDialogBeforeClose () {
      this.deleteDialogVisible = false
    },

    // 获取角色列表
    async getRolesList () {
      const data = await this.$api.setting.getRolesList()
      if (data) {
        this.rolesList = data.list
        this.params.role = data.list[0].role_id
        this.currentRole = data.list[0]
        this.currentKey = 0

        this.getUser('first')
      }
    },
    // 切换角色
    clickRole (item, index) {
      this.currentKey = index
      this.currentRole = item
      this.activeName = 'list'
      this.params.role = item.role_id
      this.getUser('first')
    },
    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getUser()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getUser()
    },

    // 获取部门用户列表
    async getUser (type) {
      this.tableloading = true
      const data = await this.$api.component.getDepartmentUser(this.params).catch(() => {
        this.tableloading = false
      })
      if (data) {
        this.userList = data.list
        this.total_count = data.total_count
        this.tableloading = false

        if (type === 'first') {
          this.totalNumber = data.total_count
        }
      }
    },

    // 切换type
    async handleClick (tab) {
      if (tab.name === 'setting') {
        const data = await this.$api.setting.getRolesInfo(this.params.role)
        if (data && data.role_list) {
          this.treeData = data
        } else {
          this.treeData = {}
        }
      }
    },

    // 保存权限范围
    async submitSetting () {
      const { role_name, role_id } = this.treeData
      this.form.role_name = role_name
      this.form.role_id = role_id
      this.form.permission = this.$refs.SetTrees.getTreeData()

      if ((this.form.permission && this.form.permission.length == 0) || !this.form.permission)
        return this.$message.error({
          message: '请选择角色权限',
          type: 'success'
        })

      const data = await this.$api.setting.editRole(this.form.role_id, this.form)
      if (data) {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.activeName = 'list'
      }
    },

    // 成员名称搜索
    searchUser () {
      this.params.page = 1
      this.getUser()
    },

    // 列表操作-角色变更弹出模态框
    updateRole (item) {
      this.permissionsVisible = true
      this.updateItem = item
    },

    // 变更角色名称
    updateName (item) {
      this.updateNameVisible = true
      this.setRoleItem = item
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.role-setting {
  display: flex;
  .menu {
    width: 300px;
    margin-right: 20px;
    position: relative;
    height: calc(100vh - 120px);
    overflow: auto;

    .add-role {
      position: absolute;
      right: 20px;
      top: 5px;
      .add-role-icon {
        font-size: 24px;
        color: #999;
      }
    }
    ::v-deep {
      .el-card__body {
        padding: 0;
      }
    }
    .role-list {
      li {
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;

        .role-name {
          width: 220px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .operation {
          display: flex;
        }

        .list-more {
          cursor: pointer;
        }
      }
      .role-selected {
        background-color: rgba(230, 247, 255, 1);
      }
    }
  }
  .list {
    flex: 1;
    height: calc(100vh - 120px);
    overflow: auto;

    .header {
      > span {
        color: #909399;
        font-size: 12px;
      }
    }

    .list-content {
      position: relative;
      .list-search {
        position: absolute;
        right: 0;
        top: 0;
      }
      .f-table-block {
        padding: 0;
      }
    }
  }

  .member {
    display: flex;
    align-items: center;
    .member-image {
      width: 32px;
      height: 32px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .member-info {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      .member-name {
        line-height: 22px;
        font-size: 12px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .member-alias {
        font-size: 10px;
        color: #909399;
        line-height: 14px;
      }
    }
  }

  .tooltip {
    cursor: pointer;
    margin-left: 4px;
    font-size: 14px;
    color: #ccc;
  }

  .setting-content {
    padding-bottom: 60px;
    .setting-btn {
      position: fixed;
      right: 100px;
      bottom: 100px;
    }
  }
}
</style>
